import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';

import {
  AspectRatio,
  Box,
  Stack,
  Text,
  VStack,
  Button,
  Divider,
} from '@frontend/components';

import { getUserEmail } from 'store/session/selectors';

import useViewTrackingReactPlayer from './useViewTrackingReactPlayer';

const Body = ({ video }) => {
  const userEmail = useSelector(getUserEmail);

  const { duration } = video;
  let secondsLapsed = video.views?.secondsLapsed;

  if (duration && secondsLapsed) {
    // if the user has watched > 90% reset
    if (duration * 0.9 < secondsLapsed) {
      secondsLapsed = null;
    }
  }

  const reactPlayerProps = useViewTrackingReactPlayer(video, {
    controls: true,
    config: {
      wistia: {
        options: {
          email: userEmail,
          resumable: true,
          time: secondsLapsed,
        },
      },
      youtube: {
        playerVars: {
          modestbranding: true,
        },
      },
    },
    height: '100%',
    width: '100%',
  });

  return (
    <Stack
      align="stretch"
      backgroundColor="white"
      direction={{ base: 'column', desktop: 'row' }}
      height={{ base: 'auto', desktop: '500px' }}
      paddingX={4}
      paddingTop={3}
      spacing={2}
    >
      <AspectRatio ratio={16 / 9} flex="2 0 0">
        <ReactPlayer {...reactPlayerProps} />
      </AspectRatio>
      <VStack align="stretch" flex="1 0 0" height="full" spacing={3}>
        <Box
          display="flex"
          flexDirection="column"
          border="1px solid"
          borderColor="separator.border"
          borderRadius="lg"
          flex="1 1"
        >
          <Box flex="1 1" overflowY="auto" padding={2}>
            <Text fontWeight="bold">Video Summary</Text>
            <Text>{video.description}</Text>
          </Box>
          {video.relatedResourcesLink ? (
            <>
              <Divider />
              <Box padding={2}>
                <Button
                  as="a"
                  size="sm"
                  target="_blank"
                  href={video.relatedResourcesLink}
                >
                  View Related Resources
                </Button>
              </Box>
            </>
          ) : null}
        </Box>
      </VStack>
    </Stack>
  );
};

export default Body;
